

























































































import { Component, Vue } from 'vue-property-decorator';
import { firebaseFunctions, firebaseApp } from '@/firebase';
import DatePicker from 'vuejs-datepicker/src/components/Datepicker.vue';
import moment from 'moment-timezone';
import { cloneDeep } from 'lodash-es';
import { downloadCSV, downloadOrders } from '@/utils/helpers';
import constants from '@/utils/constants';
import downloadOrdersApi from '@/api/modules/downloadOrders';
const OPS = 'Merchant OPS';
const MANG = 'Management';

@Component({
  components: {
    DatePicker
  }
})
export default class MenuImageBatchUpload extends Vue {
  isDownLoadBusy: boolean = false;
  now = new Date();
  initItems = {
    dateFrom: new Date(this.now.setDate(this.now.getDate() - 30)),
    dateTo: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day
    ),
    selectedOutletCodes: []
  };
  items = {
    ...this.initItems
  };
  fromDisabledDates = {
    to: new Date(
      this.currentDate.year,
      this.currentDate.month - 12,
      this.currentDate.day - 1
    ),
    from: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day - 1
    )
  };
  toDisabledDates = {
    to: new Date(
      this.currentDate.year,
      this.currentDate.month - 12,
      this.currentDate.day
    ),
    from: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day
    )
  };
  openSelectedOutletCode = false;
  outletFilterText: string = '';
  userType: string = '';
  outletCodesFromAuth: [] = [];
  $swal: any;
  mounted() {
    firebaseFunctions
      .httpsCallable('refreshAuthUser')({
        loginId: firebaseApp.auth().currentUser!.uid
      })
      .then(res => {
        const { OutletCodes, Type } = res.data.data;
        this.userType = Type;
        let outletCodes = (Type === OPS || Type === MANG) ? OutletCodes.join(',') : '';
        this.outletCodesFromAuth = OutletCodes;
        if (!outletCodes && (Type === OPS || Type === MANG)) return;
        this.$store.dispatch('GetOutletCodeListRequest', { outletCodes });
      });
  }

  get getOutletcodes() {
    return this.$store.getters.GetOutletCodeList.map(item => ({
      value: item.outletCode,
      text: `${item.outletCode} - ${item.name}`
    }));
  }

  get filteredOutletcodes() {
    const selectedCodes: any[] = this.items.selectedOutletCodes;
    const selected = this.getOutletcodes.filter((o: any) =>
      selectedCodes.includes(o.value)
    );
    const search = this.outletFilterText.toLowerCase();
    const unselected = this.getOutletcodes.filter((o: any) =>
      !selectedCodes.includes(o.value) &&
      (!search || o.text.toLowerCase().includes(search))
    );
    return [...selected, ...unselected];
  }

  get isFetchingOutletCodes() {
    return this.$store.getters.GetOutletCodeFetching;
  }

  get isFetchingDownloadData() {
    return this.$store.getters.GetDownloadOrdersFetching;
  }

  get currentDate() {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: now.getDate()
    };
  }

  updateDates() {
    if (this.items.dateTo) {
      this.fromDisabledDates.from = new Date(
        moment(this.items.dateTo).year(),
        moment(this.items.dateTo).month(),
        moment(this.items.dateTo).date() + 2
      );
    }
    if (this.items.dateFrom) {
      this.toDisabledDates.to = new Date(
        moment(this.items.dateFrom).year(),
        moment(this.items.dateFrom).month(),
        moment(this.items.dateFrom).date()
      );
    }
  }

  resetAll() {
    this.items = { ...this.initItems };
  }

  async createExportAuditLog(payload: any) {
    try {
      await downloadOrdersApi.CreateExportAuditLog(payload);
    } catch (err) {
      console.error('CreateExportAuditLog failed', err);
    }
  }

  baseAuditPayload(exportType: string, requestPath: string, payload: any, rowCount?: number | null, status = 'success', errorMessage = '') {
    const currentUser = this.$store.state.currentUser || {};
    return {
      actorLoginId: localStorage.getItem('UID') || '',
      actorEmail: currentUser.Email || '',
      actorName: currentUser.UserName || localStorage.getItem('UserName') || '',
      sourceApp: 'legacy-bo',
      exportType,
      requestPath,
      outletCodes: payload.outletCodes || payload.outlet_code || '',
      startTime: payload.start_time || '',
      endTime: payload.end_time || '',
      filtersJson: JSON.stringify(payload),
      rowCount,
      status,
      errorMessage
    };
  }

  async downLoad() {
    let startTime = cloneDeep(this.items.dateFrom);
    let endTime = cloneDeep(this.items.dateTo);
    startTime.setDate(startTime.getDate());
    endTime.setDate(endTime.getDate() + 1);
    const outletCodes = (this.userType === OPS || this.userType === MANG) ? this.items.selectedOutletCodes.join(',') ||
      this.outletCodesFromAuth.join(',') : this.items.selectedOutletCodes.join(',')
    const payload = {
      start_time: moment(startTime).format('YYYY-MM-DD'),
      end_time: moment(endTime).format('YYYY-MM-DD'),
      outletCodes,
      isAdmin: this.userType === 'Admin',
    };
    if ((this.userType === OPS || this.userType === MANG) && !this.outletCodesFromAuth.length) {
      return this.$swal(
        constants.SOMETHING_WROING,
        `You didn't bound any outlets`,
        constants.STATUS_ERROR
      );
    }
    const orderData = await this.$store.dispatch(
      'GetDownloadOrderstRequest',
      payload
    );
    if (orderData.invalidMessage !== constants.UPPER_SUCCESS) {
      await this.createExportAuditLog(this.baseAuditPayload('orders', 'orderexport', payload, null, 'failed', orderData.invalidMessage));
      return this.$swal(
        constants.SOMETHING_WROING,
        orderData.invalidMessage,
        constants.STATUS_ERROR
      );
    }
    downloadCSV(orderData.data, 'order.csv');
    await this.createExportAuditLog(this.baseAuditPayload('orders', 'orderexport', payload, Array.isArray(orderData.data) ? orderData.data.length : null));
  }

  downLoadOrderDetails() {
    let startTime = cloneDeep(this.items.dateFrom);
    let endTime = cloneDeep(this.items.dateTo);
    startTime.setDate(startTime.getDate());
    endTime.setDate(endTime.getDate() + 1);

    let payload: any;
    this.isDownLoadBusy = true;
    const outlet_code = (this.userType === OPS || this.userType === MANG) ? this.items.selectedOutletCodes.join(',') ||
      this.outletCodesFromAuth.join(',') : this.items.selectedOutletCodes.join(',')
    if ((this.userType === OPS || this.userType === MANG) && !this.outletCodesFromAuth.length) {
      this.isDownLoadBusy = false;
      return this.$swal(
        constants.SOMETHING_WROING,
        `You didn't bound any outlets`,
        constants.STATUS_ERROR
      );
    }
    firebaseFunctions
      .httpsCallable('refreshAuthUser')({
        loginId: firebaseApp.auth().currentUser!.uid
      })
      .then(res => {
        payload = {
          uid: res.data.data.UID,
          start_time: moment(startTime).format('YYYY-MM-DD'),
          end_time: moment(endTime).format('YYYY-MM-DD'),
          outlet_code
        };
        this.$store.dispatch('DownLoadOrders', payload).then(res => {
          this.isDownLoadBusy = false;
          if (res.response && res.response.status !== 200) {
            this.createExportAuditLog(this.baseAuditPayload('order_details', 'ordering/order/bo/list_by_menu_items', payload, null, 'failed', res.response.data.exceptionmsg));
            return this.$swal(
              constants.SOMETHING_WROING,
              res.response.data.exceptionmsg,
              constants.STATUS_ERROR
            );
          }
          downloadOrders(res);
          const rowCount = res && res.data && res.data.result && Array.isArray(res.data.result.data) ? res.data.result.data.length : null;
          this.createExportAuditLog(this.baseAuditPayload('order_details', 'ordering/order/bo/list_by_menu_items', payload, rowCount));
        })
      });
  }

  toggleSelectedOutletCode() {
    this.openSelectedOutletCode = !this.openSelectedOutletCode;
  }
}
